import React, { Fragment } from 'react';
import { Link } from 'Utils/history';
import ZeroState from 'Modules/Actions/components/ZeroStates/ZeroState';

const ActiveActionsZeroState = () => {
  return (
    <ZeroState
      title="You don't have any Actions due."
      subtitle={
        <Fragment>
          Actions will populate from
          <Link to="/flows"> Flows</Link>,<Link to="/spaces"> Spaces</Link> or
          One Off Actions.
        </Fragment>
      }
    />
  );
};

export default ActiveActionsZeroState;
